import { makeStyles } from '@material-ui/core/styles';
import { PRIMARY, PRIMARY_20 } from '@/theme/theme';

export const useStyles = makeStyles((theme) => ({
  formControl: {
    width: '100%',
  },
  sectionHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1.5),
  },
  sectionIcon: {
    color: PRIMARY,
    fontSize: 22,
  },
  sectionTitle: {
    fontWeight: 700,
    fontSize: '1rem',
    color: PRIMARY,
    letterSpacing: '0.02em',
  },
  sectionCard: {
    backgroundColor: '#FAFBFC',
    borderRadius: 12,
    padding: theme.spacing(2.5),
    border: '1px solid #E8ECF0',
  },
  fieldLabel: {
    fontWeight: 600,
    fontSize: '0.8rem',
    color: theme.palette.text.primary,
    marginBottom: theme.spacing(0.75),
  },
  fieldHint: {
    fontSize: '0.72rem',
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.25),
  },
  switchContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
  },
  checkboxRow: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(2),
    '& > *': {
      flex: '0 0 auto',
    },
  },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  addButton: {
    marginTop: theme.spacing(1),
    borderStyle: 'dashed',
    textTransform: 'none',
  },
  statusChip: {
    fontWeight: 600,
    fontSize: '0.8rem',
    padding: theme.spacing(0.5, 0),
  },
  divider: {
    margin: theme.spacing(0.5, 0),
  },
  paymentMethodCard: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    border: '1px solid #E8ECF0',
    backgroundColor: '#fff',
    transition: 'border-color 0.2s, box-shadow 0.2s, opacity 0.2s, transform 0.2s',
    cursor: 'grab',
    position: 'relative' as const,
    userSelect: 'none' as const,
    '&:hover': {
      borderColor: PRIMARY,
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
    },
  },
  paymentMethodCardDragging: {
    opacity: 0.4,
    border: `2px dashed ${PRIMARY}`,
    transform: 'scale(0.97)',
  },
  paymentMethodCardDragOver: {
    borderColor: PRIMARY,
    boxShadow: `0 0 0 2px ${PRIMARY}33`,
    backgroundColor: '#F0FAF0',
  },
  orderBadge: {
    position: 'absolute' as const,
    top: -10,
    left: -10,
    width: 24,
    height: 24,
    borderRadius: '50%',
    backgroundColor: PRIMARY,
    color: '#fff',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '0.72rem',
    fontWeight: 700,
    boxShadow: '0 2px 4px rgba(0,0,0,0.15)',
    zIndex: 1,
  },
  dragHandle: {
    color: theme.palette.text.secondary,
    fontSize: 18,
    marginRight: theme.spacing(0.5),
    cursor: 'grab',
  },
  greenRadio: {
    color: PRIMARY,
    '&.Mui-checked': {
      color: PRIMARY,
    },
  },
  greenButton: {
    backgroundColor: PRIMARY,
    color: '#fff',
    '&:hover': {
      backgroundColor: '#45a336',
    },
  },
  greenOutlinedButton: {
    color: PRIMARY,
    borderColor: PRIMARY,
    '&:hover': {
      borderColor: PRIMARY,
      backgroundColor: PRIMARY_20,
    },
  },
}));
